import { Card, CardContent, CardHeader } from '@billda/design-system';

export function UserBusinessDetailsEmptyCard() {
  return (
    <Card data-testid="user-business-details-empty-card">
      <CardHeader>
        <h3 className="type-h6">Business Details</h3>
      </CardHeader>
      <CardContent className="pt-3">
        <p className="type-body-md text-content-secondary">Not provided</p>
      </CardContent>
    </Card>
  );
}
